export const selectDictionaries = (state) => state.dictionaries.dictionaryList;
export const selectDictionary = (state) =>
  state.dictionaries.edit.editDictionary;
export const selectSettings = (state) => state.dictionaries.edit.tableSettings;
